import { Component, input, output } from '@angular/core';
import { PaginatorComponent } from '../paginator/paginator.component';

@Component({
    selector: 'app-mobile-table',
    templateUrl: './mobile-table.component.html',
    imports: [PaginatorComponent],
    host: {
        class: 'flex flex-col gap-2 h-full overflow-hidden'
    }
})
export class MobileTableComponent {
    public loading = input(false);
    public totalItems = input(0);
    public pageSize = input(10);
    public currentPage = input(1);
    public pageChange = output<number>();
    public pageSizeChange = output<number>();
}
